import { TileRow } from '../tiles/index.js'

const MAP = {
  light: {
    box: 'flex items-center gap-[10px] rounded-[10px] px-3 py-[10px] bg-[#f3efe5] border border-[#e2dac8]',
    label: 'text-[9px] tracking-[1.5px] text-[#8a5a2b] font-bold whitespace-nowrap',
    note: 'text-[11px] text-[#6b6455]',
  },
  dark: {
    box: 'flex flex-col items-center justify-center gap-[6px] rounded-[10px] px-4 py-[10px]',
    label: 'text-[8.5px] tracking-[2px] text-[#e2a93b] font-bold',
    note: 'text-[10px] opacity-70',
    boxStyle: { background: 'rgba(226,169,59,0.08)', border: '1px solid rgba(226,169,59,0.3)' },
  },
  industry: {
    box: 'blueprint flex flex-col items-center justify-center gap-[7px] px-[18px] py-3 bg-accent-100',
    boxRow: 'blueprint flex items-center gap-[8px] px-[10px] py-1 bg-accent-100',
    label: 'font-heading text-[9.5px] tracking-[3px] text-accent-800 font-semibold whitespace-nowrap',
    note: 'text-[10.5px] text-accent-900 whitespace-nowrap',
    boxStyle: { borderColor: 'var(--color-accent-400)' },
  },
}

export default function UkeireCard({
  theme = 'light',
  label = 'WAIT',
  tiles = [],
  note,
  width,
  vertical,
  className = '',
}) {
  const m = MAP[theme] || MAP.light
  const isCol = vertical == null ? theme === 'dark' : vertical
  const box = m.boxRow && !isCol ? m.boxRow : m.box
  return (
    <div className={`${box} ${className}`} style={m.boxStyle}>
      <span className={m.label}>{label}</span>
      <TileRow tiles={tiles} width={width} />
      {note && <span className={m.note}>{note}</span>}
    </div>
  )
}
